<template >
  <div class="deviceBind">
   <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="line-height: 36px;">可选择设备</span>
      <div style="float:left;">
        <el-button type="primary" @click="sltDevice">确认选择</el-button>
      </div>
      <div style="float:right">
        <el-input placeholder="编号/昵称/地址" v-model="searchValue" @keyup.enter.native="queryDevicByKeyword">
          <el-select v-model="searchSelect" slot="prepend" placeholder="请选择">
            <el-option label="设备编号" value="0"></el-option>
            <el-option label="设备昵称" value="1"></el-option>
            <el-option label="设备地址" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="search" @click="queryDevicByKeyword"></el-button>
        </el-input>
      </div>
    </div>
    <div class="bindTable">
      <el-table
      ref="deviceSelect"
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      height="520"
      style="width: 100%"
      @selection-change="deviceSelectionChange">
      <el-table-column
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column
        prop="num"
        header-align="center"
        min-width="95"
        label="设备编号">
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        min-width="200"
        label="昵称">
      </el-table-column>
      <el-table-column
        prop="owner"
        header-align="center"
        min-width="95"
        label="设备所属">
      </el-table-column>
      <el-table-column
        prop="payStatus"
        header-align="center"
        min-width="120"
        v-if="userType == 0"
        label="流程">
        <template scope="scope">
          <el-popover
            ref="popoverPayStatus1"
            placement="top-start"
            width="200"
            trigger="hover">
            <h4 style="text-align: center;">取货流程{{scope.row.payStatus}}</h4>
            <p>{{payStatusDes(scope.row.payStatus)}}</p>
          </el-popover>
          <span style="padding: 5px 10px;" v-popover:popoverPayStatus1>{{scope.row.payStatus}}</span>
          <i v-if="userType == 0" class="el-icon-edit" @click="popEditP(scope.row.num,scope.row.payStatus,scope.row.payPoints,scope.row.payCharge)"></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="payStatus"
        header-align="center"
        min-width="120"
        v-if="userType == 2"
        label="价格">
        <template scope="scope">
          <span style="padding: 5px 10px;">{{scope.row.payCharge}}</span>
          <!-- <i class="el-icon-edit" @click="popEditPrice(scope.row.num,scope.row.payCharge)"></i> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="spase"
        header-align="center"
        min-width="95"
        label="所在场景">
      </el-table-column>
      <el-table-column
        prop="address"
        header-align="center"
        min-width="250"
        label="设备地址">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        width="80"
        label="状态">
        <template scope="scope">
        <el-tag :type="scope.row.status === '离线' ? 'danger' : 'success'"
        close-transition>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="pager"
        header-align="center"
        width="100"
        label="货物量">
        <template scope="scope">
        <span v-if="scope.row.pager/scope.row.paperVolume > 0.75" 
        style="color:#13CE66">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.50" 
        style="color:#b8ce13">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.25" 
        style="color:#F7BA2A">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else 
        style="color:#FF4949">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[50, 100, 150, 200, pageTotal]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
     <p style="text-align:left;color:#ff4949;font-size:12px;">注意：只能选择当前页面机器（通过修改右下角的页面显示数量达到选择需求）</p>
  </el-card>
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import {isNull} from '../../js/tool'
    export default {
      data () {
        return {
          deviceData: [],
          value4: 1,
          myEditPopShow: false,
          myEditPriceShow: false,
          pageTotal: 0,
          pageSize: 50,
          pageNo: 1,
          userType: this.$store.state.userType,
          table_loading: false,
          spaceTypeList: '',
          allotPopRightOk: false,
          multipleSelection: '',
          deviceSelect: [],
          allotType: '',
          seePopRightOk: false,
          deviceCode: '',
          eStatus: '',
          ePoints: '',
          ePrice: '',
          seeType: '',
          allotShow: false,
          seeShow: false,
          searchValue: '',
          searchSelect: '0',
          deviceId: '',
          uuid: ''
        }
      },
      created: function () {
        this.pageNo = 1
        this.getSpaseTypeList()
      },
      methods: {
        getSpaseTypeList () {
          var _this = this
          $axios.get('/device/getDeviceIndustry', null, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$store.state.spaceDataList = res.resultData.list
              _this.spaceTypeList = _this.$store.state.spaceDataList
              _this.queryDeviceList(_this.pageNo, _this.pageSize, '')
            }
          })
        },
        queryDeviceList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: 1
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/device/getDeviceList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    num: itemData.deviceCode,
                    uuid: itemData.uuid,
                    id: itemData.id,
                    name: itemData.alias,
                    owner: itemData.nickName,
                    payStatus: isNull(itemData.devicePoint) ? '无' : itemData.devicePoint.status,
                    payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                    payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                    spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                    address: itemData.address,
                    status: itemData.isOnline === 0 ? '离线' : '在线',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        queryDeviceListByKey (tType, tKeyWord, tPageNo, tPageSize) {
          var _this = this
          var params = {
            type: tType,
            keyword: tKeyWord,
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: 1
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/device/query', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    num: itemData.deviceCode,
                    uuid: itemData.uuid,
                    id: itemData.id,
                    name: itemData.alias,
                    owner: itemData.nickName,
                    payStatus: isNull(itemData.devicePoint) ? '无' : itemData.devicePoint.status,
                    payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                    payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                    spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                    address: itemData.address,
                    status: itemData.isOnline === 0 ? '离线' : '在线',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        deviceSelectionChange (val) {
          this.deviceSelect = val
          this.multipleSelection = ''
          this.deviceId = ''
          for (var i = 0; i < val.length; i++) {
            this.multipleSelection += (val[i].num + '|')
            this.deviceId += (val[i].id + '|')
          }
        },
        sltDevice () {
          this.$emit('closePopDevice', this.multipleSelection)
        },
        getDeviceSpaceValue (items, index) {
          var returnData
          if (isNull(index) || isNull(items)) {
            returnData = '无'
          } else {
            for (var i = 0; i < items.length; i++) {
              if (index === items[i].id) {
                returnData = items[i].name
              }
            }
          }
          return returnData
        },
        queryDevicByKeyword () {
          this.pageNo = 1
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        payStatusDes (num) {
          var payStatusDesValue = [{
            key: 0,
            value: '文章标准'
          }, {
            key: 1,
            value: '文章纯积分(已停止使用)'
          }, {
            key: 2,
            value: '支付页购买(已停止使用)'
          }, {
            key: 3,
            value: '承德888'
          }, {
            key: 4,
            value: '支付无页面(已停止使用)'
          }, {
            key: 5,
            value: '长按标准(已停止使用)'
          }, {
            key: 6,
            value: '纯支付--支持支付宝和微信'
          }, {
            key: 7,
            value: '长按每天一包(已停止使用)'
          }, {
            key: 8,
            value: '每天长按一包'
          }, {
            key: 9,
            value: '每天多包,长按,可以左右滑动(停止使用)'
          }, {
            key: 10,
            value: '每天多包,长按,可以左右滑动,有再来一次按钮'
          }, {
            key: 1001,
            value: '嘉兴的流程(定制的流程)'
          }]
          var returnData
          if (num === '无') {
            returnData = '未知流程'
          } else {
            returnData = '未知流程'
            for (var i = 0; i < payStatusDesValue.length; i++) {
              if (num === payStatusDesValue[i].key) {
                returnData = payStatusDesValue[i].value
              }
            }
          }
          return returnData
        }
      },
      components: {
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .deviceBind {
        .el-select .el-input {
          width: 110px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/adMgr/popDevice.vue